import React from 'react'
import './GridListLoading.scss'

const GridListLoading = () => {

  return (
    <div className='viso-grid-list-loading'>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((row, index) => (
        <div key={index} className='viso-grid-list-loading__row' />
      ))}
    </div>
  )
}

export default GridListLoading